export default __webpack_public_path__ + "static/media/output.476cc656.webm";